/**
 * E8-P1 — logic thuần cho nút/chip LOOK-ASSET ở Look Bank. Tách khỏi file import antd để test được dưới
 * jest của react-scripts (antd v6 + react-router v7 không load được ở đó — xem CLAUDE.md).
 *
 * Điều đáng nói nhất ở màn này: bấm "Đăng ký asset" khi look CHƯA có ảnh look-ref sẽ **tốn thêm một lượt
 * gen ảnh** (server tự gen trước rồi mới đăng ký). Người bấm phải biết trước — mỗi lượt gen là tiền thật.
 */
export interface LookAssetLike {
    seedanceLookAssetId?: string | null;
    seedanceLookAssetAt?: string | null;
    /** Ảnh look-ref (MẶT + đúng bộ đồ) — đầu vào của việc đăng ký asset. */
    canonicalRefUrl?: string | null;
}

export interface LookAssetChip { cls: 'ok' | 'no'; text: string; title: string }

/** Chip trạng thái cạnh chip "Outfit ref". */
export function lookAssetChip(l: LookAssetLike): LookAssetChip {
    if (l?.seedanceLookAssetId) {
        const when = l.seedanceLookAssetAt ? new Date(l.seedanceLookAssetAt).toLocaleDateString() : '';
        return {
            cls: 'ok',
            text: '✓ Look asset',
            title: `Ảnh look (mặt + bộ đồ) đã đăng ký asset ${l.seedanceLookAssetId}${when ? ` — ${when}` : ''}. Khi bật FILM_LOOK_ASSET, clip gửi CHÍNH ảnh này thay cho digital character + ảnh outfit.`,
        };
    }
    return { cls: 'no', text: '✗ Look asset', title: 'Chưa đăng ký — clip vẫn đi đường cũ (digital character + ảnh outfit rời).' };
}

export interface LookAssetAction {
    label: string;
    /** true ⇒ hành động sẽ XOÁ asset (trả quota), cần hỏi lại. */
    danger: boolean;
    /** Bấm nút này có kéo theo một lượt gen ảnh không (tiền thật). */
    costsImageGen: boolean;
    title: string;
}

/** Nút một-cái-cho-hai-việc: chưa có ⇒ đăng ký; đã có ⇒ xoá (trả slot trong quota 50 dùng chung). */
export function lookAssetAction(l: LookAssetLike): LookAssetAction {
    if (l?.seedanceLookAssetId) {
        return {
            label: 'Xoá asset', danger: true, costsImageGen: false,
            title: 'Trả slot quota về (quota 50 asset dùng chung toàn tổ chức). Ảnh look-ref vẫn còn, đăng ký lại được.',
        };
    }
    const costsImageGen = !l?.canonicalRefUrl;
    return {
        label: costsImageGen ? 'Gen + đăng ký asset' : 'Đăng ký asset',
        danger: false,
        costsImageGen,
        title: costsImageGen
            ? '⚠️ Look chưa có ảnh look-ref: bấm nút này sẽ GEN ẢNH trước (tốn một lượt image-gen) rồi mới đăng ký.'
            : 'Đăng ký ảnh look-ref hiện có thành asset để gửi engine bằng asset:// (ảnh có mặt gửi bằng URL bị chặn).',
    };
}

/** Đếm cho dòng tóm tắt đầu tab — biết ngay đang chiếm bao nhiêu slot trong quota. */
export function countLookAssets(looks: LookAssetLike[]): number {
    return (looks || []).filter((l) => !!l?.seedanceLookAssetId).length;
}
